import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import { SharedStateContext } from "../pages/Dashboard";

const API_URL = process.env.REACT_APP_API_URL


const EventCard = ({ event, user }) => {
	const navigate = useNavigate();
	const [eventActive, setEventActive] = useState(false);
	const { switchTriggered, setSwitchTriggered } = useContext(SharedStateContext)

	useEffect(() => {
		const getEvent = async () => {
		  await fetch(`${API_URL}/firebase/get-event`, {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify({
			  eventId: event.UID,
			})
		  }).then((res) => res.json())
		  .then((res) => {
				setEventActive(res.Active)
		  })
		}
		getEvent();
	}, [event, switchTriggered])

	const setEventActiveFunction = async (eventActiveValue) => {
		setEventActive(!eventActive)
		await fetch(`${API_URL}/firebase/update-event-active`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				userEmail: user.email,
				eventId: event.UID,
				activateEvent: eventActiveValue
			})
		})
		setSwitchTriggered(!switchTriggered)
	}
	
	return (
		<>
			{
				event !== undefined ? 
				<>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						className="bg-[#a3c9ff] py-3 pl-4 pr-6 rounded-2xl mt-1">
						<Box>
							<h4 className="text-white">{event.Name}</h4>
							<p className="text-black">{event.Date}</p>
						</Box>
						<Stack spacing={2} direction="row" sx={{ width: 300 }}>
							{
								user && <label style={{ marginLeft: "auto", marginTop: "auto"}} className="switch">
									<input style={{ color: 'green' }}
										type="checkbox"
										checked={eventActive}
										onChange={() => setEventActiveFunction(!eventActive)}
									/>
									<span style={{ backgroundColor: eventActive ? 'green' : 'grey' }} className="slider" />
								</label>
							}
							<button onClick={()=> {navigate(`/Events/${event.UID}`)}} className="bg-[#0060AB] px-4 rounded-[40px] h-10 tracking-widest  text-black font-medium">
								Open
							</button>
						</Stack>
					</Stack>
				</> : <></>
			}
		</>
	)
}

export default EventCard;